import React, {Component} from 'react'
import {_getListKeywords, _removeKeyword} from "../../../../../services/apis/KeywordServices"
import CreateNewKeyword from "./CreateNewKeyword"
import ListKeywords from "./ListKeywords"
import SearchKeywordStatistic from "./SearchKeywordStatistic"
import {Alert} from "reactstrap";

class KeywordManager extends Component {
    state = {
        docs: [],
        total: 0,
        pagination: {
            page: 1,
            limit: 1000,
            pages: 1,
        },
        countResults: 0,
        error: ''
    }

    _refresh = null
    _totalResults = new Map()

    componentDidMount() {
        this._fetchListKeywords()

        this._refresh = setInterval(this._fetchListKeywords, 5000)
    }

    componentWillUnmount() {
        this._refresh && clearInterval(this._refresh)
    }

    _fetchListKeywords = async () => {
        const {page, limit} = this.state.pagination

        const {success, data, message} = await _getListKeywords(page, limit)
        if (success) {
            const {docs} = data

            this.setState({
                docs
            })
        } else {
            this.setState({error: message})
        }
    }

    _handleCreate = (keyword) => {
        this.setState(({docs}) => ({
            docs: [].concat([keyword], docs)
        }))
    }

    _handleRemoveKeyword = (keywordId) => {
        const r = window.confirm('Are you sure want to remove this keyword?')
        if (!r) return

        this.setState(({docs}) => ({
            docs: docs.filter(keyword => keyword._id !== keywordId)
        }))

        this._requestRemoveKeyword(keywordId)
    }

    _requestRemoveKeyword = async keywordId => {
        await _removeKeyword(keywordId)
    }

    _handleUpdateTotal = (keywordId, total) => {
        this._totalResults.set(keywordId, total)
        this._updateTotalResults()
    }

    _updateTotalResults = () => {
        const {countResults} = this.state

        let newCount = 0
        this._totalResults.forEach((count) => {
            newCount += count
        })

        if (newCount !== countResults) {
            this.setState({
                countResults: newCount
            })
        }
    }

    render() {
        const {docs, countResults, error} = this.state

        return (
            <div>
                {
                    !!error ? <Alert color="danger">{error}</Alert> :
                        <div className="KeywordManager">
                            <div className="row">
                                <CreateNewKeyword onCreate={this._handleCreate}/>
                                <SearchKeywordStatistic/>
                            </div>

                            <ListKeywords
                                countResults={countResults}
                                onCountTotal={this._handleUpdateTotal}
                                onRemove={this._handleRemoveKeyword}
                                keywords={docs}/>
                        </div>
                }
            </div>
        )
    }
}

export default KeywordManager



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/keywords/components/KeywordManager.js